import type { TaskResult } from "../types";

const ACCESORIOS_DATA = [
  [101, "Esquí de rendimiento único", 30, 20],
  [102, "Tabla de snowboard", 30, 20],
  [103, "Botas", 8, 5],
  [104, "Postes", 7, 5],
  [105, "Casco", 7, 5],
  [106, "Raquetas de nieve", 10, 8],
  [107, "Tobogán", 40, 30],
  [108, "Trineo", 20, 15],
  [109, "Tubo", 8, 5],
];

export async function gradeProject11(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Importar Accesorios.csv en nueva hoja dentro de una tabla
  // (Power Query siempre crea una tabla al importar; verificamos datos + tabla)
  try {
    await Excel.run(async (context) => {
      const sheets = context.workbook.worksheets;
      sheets.load("items/name");
      await context.sync();

      let found = false;
      for (const ws of sheets.items) {
        if (ws.name === "Tarifa de alquiler") continue;

        // Check if this sheet has tables (Power Query import always creates a table)
        const tables = ws.tables;
        tables.load("items");
        try {
          await context.sync();
        } catch {
          continue;
        }
        if (tables.items.length === 0) continue;

        // Read the data from the first table
        const tableRange = tables.items[0].getDataBodyRange();
        tableRange.load("values,rowCount,columnCount");
        try {
          await context.sync();
        } catch {
          continue;
        }

        if (tableRange.rowCount < ACCESORIOS_DATA.length || tableRange.columnCount < 4) continue;

        const vals = tableRange.values;

        // Verify all 9 rows of accessory data exist
        let allMatch = true;
        for (let i = 0; i < ACCESORIOS_DATA.length; i++) {
          const row = vals[i];
          if (!row) { allMatch = false; break; }
          if (Number(row[0]) !== ACCESORIOS_DATA[i][0]) { allMatch = false; break; }
        }

        if (allMatch) {
          found = true;
          break;
        }
      }

      results.push({ taskId: 1, passed: found });
    });
  } catch {
    results.push({ taskId: 1, passed: false });
  }

  // Tarea 2: Borrar formato en A4:D4 de "Tarifa de alquiler"
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Tarifa de alquiler");
      // Check just cell A4 (single cell avoids matrix mismatch)
      const cell = ws.getRange("A4");
      cell.format.fill.load("color");
      cell.format.font.load("color");
      await context.sync();

      const fillColor = (cell.format.fill.color || "").toUpperCase();
      const fontColor = (cell.format.font.color || "").toUpperCase();

      // After clearing formats, fill should not be dark green and font not white
      const fillCleared = fillColor !== "#375623";
      const fontCleared = fontColor !== "#FFFFFF";

      results.push({ taskId: 2, passed: fillCleared && fontCleared });
    });
  } catch {
    results.push({ taskId: 2, passed: false });
  }

  // Tarea 3: Renombrar tabla de "Tabla1" a "Tarifas"
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Tarifa de alquiler");
      const tables = ws.tables;
      tables.load("items/name");
      await context.sync();

      let passed = false;
      for (const t of tables.items) {
        if (t.name === "Tarifas") {
          passed = true;
          break;
        }
      }
      results.push({ taskId: 3, passed });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  // Tarea 4: Orientación horizontal (landscape) en "Tarifa de alquiler"
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Tarifa de alquiler");
      ws.pageLayout.load("orientation");
      await context.sync();

      const orientation = String(ws.pageLayout.orientation).toLowerCase();
      const passed =
        orientation === "landscape" || orientation === "horizontal";
      results.push({ taskId: 4, passed });
    });
  } catch {
    results.push({ taskId: 4, passed: false });
  }

  // Tarea 5: Comprobar compatibilidad — buscar hoja cuyo A1 contenga el texto del informe
  try {
    await Excel.run(async (context) => {
      const sheets = context.workbook.worksheets;
      sheets.load("items/name");
      await context.sync();

      let found = false;
      for (const ws of sheets.items) {
        if (ws.name === "Tarifa de alquiler") continue;

        const cell = ws.getRange("B1");
        cell.load("values");
        try {
          await context.sync();
        } catch {
          continue;
        }

        const value = String(cell.values[0][0]).toLowerCase();
        // ES: "Informe de compatibilidad para..."
        // EN: "Compatibility Report for..."
        if (value.includes("compatib")) {
          found = true;
          break;
        }
      }

      results.push({ taskId: 5, passed: found });
    });
  } catch {
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
